import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface AccordionItemProps {
  question: string;
  answer: string;
}
export function AccordionItem({
  question,
  answer
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-199">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 px-2 flex items-center justify-between text-left focus:outline-none group" data-id="element-200">
        <span className="text-lg font-semibold text-gray-800 group-hover:text-orange-600 transition-colors" data-id="element-201">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-orange-500" data-id="element-202" /> : <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-orange-500 transition-colors" data-id="element-203" />}
      </button>
      <AnimatePresence data-id="element-204">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-205">
            <div className="pb-4 px-2 text-gray-600 leading-relaxed" data-id="element-206">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}